(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { useState, useEffect } from "react";

const useKeyPress = targetKey => {
  const [keyPressed, setKeyPressed] = useState(false);

  function downHandler(_ref) {
    let {
      key
    } = _ref;

    if (key === targetKey) {
      setKeyPressed(true);
    }
  }

  function upHandler(_ref2) {
    let {
      key
    } = _ref2;

    if (key === targetKey) {
      setKeyPressed(false);
    }
  }

  useEffect(() => {
    window.addEventListener("keydown", downHandler);
    window.addEventListener("keyup", upHandler);
    return () => {
      window.removeEventListener("keydown", downHandler);
      window.removeEventListener("keyup", upHandler);
    };
  });
  return keyPressed;
};

__signature__(useKeyPress, "useState{[keyPressed, setKeyPressed](false)}\nuseEffect{}");

const _default = useKeyPress;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useKeyPress, "useKeyPress", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/hooks/useKeyPress.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/hooks/useKeyPress.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();